module.exports = __webpack_public_path__ + "static/images/copy.2HHjORn.svg";